export const urlBuilding = {
  localUrl: 'http://localhost:8080',
  stageUrl: 'https://stage.cbmportal.com:8443',
};

/**
 * Get the backend URL based on the current hostname
 * Centralizes the URL determination logic that was duplicated across state files
 * @returns {string} The appropriate backend URL
 */
export const getBackendUrl = () => {
  if (typeof window === 'undefined') return urlBuilding.localUrl;
  return window.location.hostname.includes('stage')
    ? urlBuilding.stageUrl
    : urlBuilding.localUrl;
};
